import { render, staticRenderFns } from "./procedimiento-auditoria.vue?vue&type=template&id=19c821a9&"
import script from "./procedimiento-auditoria.vue?vue&type=script&lang=js&"
export * from "./procedimiento-auditoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports